import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const ShareAndRestrictDialogController: LoadableType<any> = LoadableLazy<any>({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ShareAndRestrictDialogController" */ './Controller.tsx'
			)
		).Controller,
});
